<template>
    <nav>
      <ul>
<!--
          <li class="link_button" v-for="rota in rotas">
            <router-link :to="rota.path ? rota.path : '/'">
              {{ rota.titulo }}
            </router-link>
          </li> -->
          <li class="link_button">
            <router-link to='/'>
              Requerimento LGPD - MPT
            </router-link>
          </li>
          <li class="link_button">
            <router-link to='/acompanhamento-requerimento'>
              Acompanhamento Requerimento
            </router-link>
          </li>
      </ul>
    </nav>
</template>

<script>

export default {

    props: {

        rotas: {
            type: Array,
            required: true
        }
    }
}

</script>

<style>
nav {
  padding-top: 10em;
  background-color: #2A3A4A;
}
ul {
  list-style-type: none; /* Remove bullets */
  padding: 0px;
}

a {
  color: black;
}

li {
margin-left: 1em;
margin-right: 1em;
margin-bottom: 1em;
}

.link_button {
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    border: solid 1px #20538D;
    text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.4);
    background: white;
    padding: 8px 12px;
    text-decoration: none;
    text-align: center;

}

@media (max-width: 678px) {
  nav{
      padding-top: 2em!important;
      padding-bottom: 1em!important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue